import { useEffect } from 'react'

const AppUpdateBinder = () => {
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      window.workbox !== undefined
    ) {
      const wb = window.workbox

      wb.addEventListener('waiting', () => {
        const wb = window?.workbox
        wb.messageSkipWaiting()
      })
    }
  }, [])
  return <></>
}

export default AppUpdateBinder
